import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { ModuleHeader } from "./ModuleHeader";
import { LoginAnnouncementsPopup } from "@/features/announcements/LoginAnnouncementsPopup";

export function AppShell() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden bg-slate-50">
      {/* At lg+ the sidebar is a normal, in-flow flex sibling (see its own
          `lg:static`) - its width alone (full nav vs. compact icon rail)
          determines how much room is left for this column, so no extra
          margin/push state is needed here any more. */}
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar onMenuClick={() => setSidebarOpen((v) => !v)} />
        {/* `relative` makes main the containing block for absolutely positioned
            descendants (every `sr-only` label in a table, for one). Without it
            they position against the window and, because main scrolls and the
            shell is only overflow-hidden, stretch the DOCUMENT taller than the
            screen: the sidebar scrolled away and a blank band appeared. */}
        <main className="relative flex-1 overflow-y-auto scrollbar-thin p-4 sm:p-6">
          {/* The module context strip (name + tabs + More) sits here rather
              than in the sidebar: the sidebar stays stable across modules,
              and this is what changes as you move between them. Renders
              nothing on routes that belong to no module. */}
          <ModuleHeader />
          <Outlet />
        </main>
      </div>
      {/* Events & Announcements login popup - here, inside the authenticated
          shell, so it can only ever run after login has succeeded and can
          never hold the login screen up. */}
      <LoginAnnouncementsPopup />
    </div>
  );
}
